//Library Imports
import React, { useState } from "react";

// application components goes here
import GlobalStyle from "../../../../GlobalStyle";
import Button from "../../../Common/Components/Button";
import { ReactComponent as CrossIcon } from "../../../../assets/img/icons/cross.svg";
import { setNewPassword } from "modules/Services/LoginService";

// styles goes here
import styled from "styled-components";
import Input from "modules/Common/Components/Input";
import Message from "modules/Common/Components/Message";
import { validateSetNewPasswordFields } from "modules/Login/Utils";
import { ISetNewPassword } from "../Interfaces";

type SetNewPasswordProps = {
  setRedirectPath: (val: string) => void;
  resetKey: string;
};

const SetNewPassword: React.FC<SetNewPasswordProps> = (props: SetNewPasswordProps) => {
  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
  });
  // show errors
  const [errors, setErrors] = useState<ISetNewPassword>({});
  const [showPassword, togglePassword] = useState(false);
  const [showConfirmPassword, toggleConfirmPassword] = useState(false);
  // show loading when button clicked
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    status: false,
    message: "",
    type: "error",
    label: "Error!",
  });

  const handleSetPasswordSubmit = () => {
    setMessage({
      status: false,
      message: "",
      type: "error",
      label: "Error!",
    });
    const validationMessage = validateSetNewPasswordFields(values.password, values.confirmPassword);
    setErrors(validationMessage.errors);
    if (validationMessage.status) {
      setMessage({
        status: true,
        message: validationMessage.message,
        type: "error",
        label: "Error!",
      });
    }
    if (validationMessage.status) return;

    setLoading(true);
    let formData = new FormData();
    formData.append("password", values.password);
    formData.append("key", props.resetKey);
    setNewPassword(formData)
      .then((res) => {
        if (res.data.status === "success") {
          if (res.data.message === "Password reset link has expired.") {
            setMessage({
              status: true,
              message: res.data.message,
              type: "error",
              label: "Thanks!",
            });
          } else {
            setMessage({
              status: true,
              message: res.data.message,
              type: "success",
              label: "Thanks!",
            });
            setTimeout(() => {
              props.setRedirectPath("");
            }, 3000);
          }
        } else if (res.data.status === "False") {
          setMessage({
            status: true,
            message: res.data.message,
            type: "error",
            label: "Error!",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response?.data?.status === "False") {
          setMessage({
            status: true,
            message: err.response.status === 400 ? "Something went wrong" : err.response.data.message,
            type: "error",
            label: "Error!",
          });
        }
      });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (message.status) {
      setMessage((state) => ({ ...state, status: false }));
    }
    if (e.target.value.length > 20) return;
    setValues((state) => ({ ...state, [e.target.name]: e.target.value }));
    if (e.target.name === "confirmPassword" && e.target.value?.length > 0 && e.target.value !== values.password) {
      setErrors({ ...errors, password2: "Password doesn't match" });
    } else if (e.target.name === "confirmPassword" && errors.password2) {
      let errorObject = { ...errors };
      delete errorObject.password2;
      setErrors(errorObject);
    }
  };

  return (
    <>
      <GlobalStyle />
      <SetNewPasswordWrapper>
        <span className="cross-btn" onClick={(e) => props.setRedirectPath("")}>
          <CrossIcon />
        </span>
        <h3>Enter new password</h3>
        {message.status ? <Message type={message.type} label={message.label} message={message.message} /> : ""}

        <Input
          value={values.password}
          className="password padding-right-password"
          is_password="true"
          error={errors.password}
          name="password"
          label="New password"
          type={showPassword ? "text" : "password"}
          onFocus={() => {
            let errorObject = { ...errors };
            delete errorObject.password;
            setErrors(errorObject);
          }}
          placeholder="Enter your password…"
          togglePassword={(e: EventListener) => togglePassword(!showPassword)}
          onChange={handleChange}
        />
        <Input
          value={values.confirmPassword}
          className="password padding-right-password"
          is_password="true"
          name="confirmPassword"
          error={errors.password2}
          label="Confirm new password"
          type={showConfirmPassword ? "text" : "password"}
          onFocus={() => {
            let errorObject = { ...errors };
            delete errorObject.password2;
            setErrors(errorObject);
          }}
          placeholder="Enter your password…"
          togglePassword={(e: EventListener) => toggleConfirmPassword(!showConfirmPassword)}
          onChange={handleChange}
        />
        <div className="spacer-div" />
        <Button
          value={loading ? "Loading..." : "Change Password"}
          disabled={loading}
          onClick={handleSetPasswordSubmit}
        />
        <p>
          Did you forget your
          <span className="span" onClick={(e) => props.setRedirectPath("username")}>
            username
          </span>
          ?
        </p>
      </SetNewPasswordWrapper>
    </>
  );
};

export default SetNewPassword;

/**
 * * We Only need to use connect when we are providing mapStateToProps or mapActionsToProps
 * * otherwise we can use useSelector or useDispatch of react-redux in functional components
 */

const SetNewPasswordWrapper = styled.div`
  margin: 0px;
  padding: 50px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  position: relative;
  font-family: "robotoregular";

  h3 {
    color: #424b50;
    font-family: "robotoregular";
    font-weight: 600;
  }
  .cross-btn {
    position: absolute;
    right: 18px;
    top: 20px;
    cursor: pointer;
  }
  .content-wrapper {
    margin-top: 75px;
    margin-bottom: 0px;
    h2 {
      margin-top: 30px;
    }
  }
  .input-field-spacing {
    margin-top: 25px;
    margin-bottom: 35px;
  }
  h2 {
    color: #424b50;
    font-size: 54px;
    margin: 64px 0 10px 0;
    font-weight: bold;
    text-align: left;
  }

  p {
    font-size: 14px;
    color: #5e7079;
    margin: 27px 0 0 0;
    font-family: "robotoregular";
    font-weight: 600;
    a {
      color: #27ce0a !important;
      font-weight: 700;
      text-decoration: none;
    }
    .span {
      cursor: pointer;
      margin: 0 3px;
      color: #27ce0a !important;
      font-weight: 700;
      text-decoration: none;
    }
  }
  label {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin: 16px 0 5px 0;
      font-size: 14px;
    }
  }
  input[type="text"],
  input[type="password"] {
    @media all and (max-width: 1439px) {
      font-size: 16px;
      line-height: 20px;
      padding: 8px 18px;
      &.password + span {
        top: 13px;
      }
    }
  }
  .spacer-div {
    width: 100%;
    height: 20px;
  }
`;
